import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams, useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Container from "react-bootstrap/Container";

import ApiService from "../../_services/ApiService";
import Config from "../../_config/config";
import UserService from "../../_services/UserService";
import { TestResultContext } from "../../contexts/test-result.context";

import QuestionPaper from "../test-player/components/question-paper.component";
import { ILoader } from "../../_components/iloader/iloader";

import "./render-question-paper.styles.css";

const RenderQuestionPaper = () => {
  const {getTestResult} = useContext(TestResultContext);
  const history = useHistory();
  const { testId } = useParams();
  const [testObject, setTestObject] = useState({});
  const [questionWiseAnalysis, setQuestionWiseAnalysis] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  let portlet = JSON.parse(localStorage.getItem("portlet")) || [];

  const location = useLocation();
  const { state } = location;
  const {testPaperSolution} = state || {};

  const fetchQuestionPaperUrl = async(url)=>{
    try{
      const data = await ApiService.fetchUrl(url);
      return {testPaper:data.data};

    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    const fetchQuestionPaper = async () => {
      const userId = UserService.getUserId();
      const body = {
        tenant: Config.siteTitle,
        testId,
        userId,
        enquiryId: UserService.getEnquiryId()
      };

      console.log(body);
      setIsLoading(true);
      try {
        const [testPaperResponse, questionWiseAnalysisRes] = await Promise.all([testPaperSolution?fetchQuestionPaperUrl(testPaperSolution):ApiService.fetchQuestionPaper(body),getTestResult(testId)]);
        console.log(testPaperResponse);
        const { testPaper } = testPaperResponse;
        setQuestionWiseAnalysis(questionWiseAnalysisRes?.data);
        setTestObject(testPaper);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    };
    fetchQuestionPaper();
  }, []);

  return (
    <div className="testlist">
      {
        <Container fluid>
          <div
            className={`module-header-step2 ${
              portlet.class ? portlet.class : "test-list-default-portlet"
            }`}
          >
            <div className="">
              <div className="back">
                <FontAwesomeIcon icon={faArrowLeft} onClick={history.goBack} />
              </div>
              <h4 id="testname">Test Paper Solution</h4>
            </div>
          </div>
          <div className="question-paper-container">
            <ILoader loadingText={"Please wait..."} isShow={isLoading} />
            <div className="profiling-header">
              <div>
                <span className="profiling-heading">Test Name : </span>
                <span className="profiling-details">
                  {testObject?.name}
                </span>
              </div>
              <button
                className="detailed-profiling-download-test"
                onClick={window.print}
              >
                Download Page
              </button>
            </div>
            <div className="question-paper-wrapper">
              <QuestionPaper testObject={testObject} questionWiseAnalysis={questionWiseAnalysis} />
            </div>
          </div>
        </Container>
      }
    </div>
  );
};

export default RenderQuestionPaper;
